module.exports = __webpack_public_path__ + "img/com.electrolux.connectapphub.android.71b46995.webp";